import BusinessLogicException from 'exceptions/BusinessLogicException';

export class HasUnsavedChangesException extends BusinessLogicException {}

export default HasUnsavedChangesException;
